<template>
  <div class="card-container channel">
    <el-card>
      <common-el-form
        :model="formModel"
        :rules="formRules"
        :submitData="submitData"
        @success="onSuccess"
        submit-btn-text="提交"
        failTitle="提交失败"
        loadingText="提交中..."
        :submitService="submitService"
        :showButton="false"
      >
        <div style="display: flex; flex-wrap: wrap">
          <div style="min-width: 300px">
            <el-form-item label="赛事名称" prop="gameName">
              <el-input
                type="text"
                maxlength="20"
                v-model="formModel.gameName"
                placeholder="请输入"
                style="width: 180px"
              ></el-input>
            </el-form-item>
          </div>
          <div style="min-width: 301px">
            <el-form-item label="App显示排名" prop="topNumber">
              <el-input-number
                v-model="formModel.topNumber"
                :min="3"
                :max="999999999"
                :step="0"
                :precision="0"
                :controls="false"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="logo" prop="logoUrl">
          <el-upload
            class="avatar-uploader"
            :action="uploadUrl + '8883/picture/upload'"
            :data="commonParams"
            name="picture"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="formModel.logoUrl"
              :src="formModel.logoUrl"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <span style="margin-top: -25px">月榜奖励</span>
        <div style="display: flex; flex-wrap: wrap">
          <div style="min-width: 300px">
            <el-form-item label="冠军（元）" prop="monthFirst">
              <el-input-number
                style="width: 180px"
                v-model="formModel.monthFirst"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="亚军（元）" prop="monthSecond">
              <el-input-number
                style="width: 180px"
                v-model="formModel.monthSecond"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="季军（元）" prop="monthThird">
              <el-input-number
                style="width: 180px"
                v-model="formModel.monthThird"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>

        <span>周榜奖励</span>
        <div style="display: flex; flex-wrap: wrap">
          <div style="min-width: 300px">
            <el-form-item label="冠军（元）" prop="weekFirst">
              <el-input-number
                style="width: 180px"
                v-model="formModel.weekFirst"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="亚军（元）" prop="weekSecond">
              <el-input-number
                style="width: 180px"
                v-model="formModel.weekSecond"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="季军（元）" prop="weekThird">
              <el-input-number
                style="width: 180px"
                v-model="formModel.weekThird"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>

        <span>积分规则</span>
        <div style="display: flex; flex-wrap: wrap">
          <div style="min-width: 300px">
            <el-form-item label="欢乐返（分）" prop="integralHlf">
              <el-input-number
                style="width: 180px"
                v-model="formModel.integralHlf"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="押金199（分）" prop="integral199">
              <el-input-number
                style="width: 180px"
                v-model="formModel.integral199"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
          <div style="min-width: 300px">
            <el-form-item label="押金299（分）" prop="integral299">
              <el-input-number
                style="width: 180px"
                v-model="formModel.integral299"
                :controls="false"
                :precision="2"
                :step="0.1"
                controls-position="right"
                :min="0"
                placeholder="请输入"
              ></el-input-number>
            </el-form-item>
          </div>
        </div>
        <el-form-item label="开关" prop="status">
          <el-switch
            v-model="formModel.status"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </el-form-item>
      </common-el-form>
    </el-card>
  </div>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";
import SelectLevel from "components/business/SelectLevel";
import ElFormItem from "element-ui/packages/form/src/form-item";
import APPService from "service/APPService";
import Server from "common/conf/Server";
import privateKey from "service/constant/privateKey";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "rankingmanage",
  data() {
    return {
      uploadUrl: Server[process.env.NODE_ENV],
      formRules: {
        gameName: [
          {
            required: true,
            message: "请输入",
          },
        ],
        topNumber: [
          {
            required: true,
            message: "请输入",
          },
        ],
        // logoUrl: [
        //   {
        //     required: true,
        //     validator: (rule, value, callback) => {
        //       console.log(this.formModel.logoUrl);
        //       //   if (!value) {
        //       //     return callback(new Error("请选择"));
        //       //   } else {
        //       //     return callback();
        //       //   }
        //     },
        //   },
        // ],

        monthFirst: [
          {
            required: true,
            message: "请输入",
          },
        ],
        monthSecond: [
          {
            required: true,
            message: "请输入",
          },
        ],
        monthThird: [
          {
            required: true,
            message: "请输入",
          },
        ],

        weekFirst: [
          {
            required: true,
            message: "请输入",
          },
        ],
        weekSecond: [
          {
            required: true,
            message: "请输入",
          },
        ],
        weekThird: [
          {
            required: true,
            message: "请输入",
          },
        ],

        integralHlf: [
          {
            required: true,
            message: "请输入",
          },
        ],
        integral199: [
          {
            required: true,
            message: "请输入",
          },
        ],
        integral299: [
          {
            required: true,
            message: "请输入",
          },
        ],
      },
      formModel: {
        gameName: "",
        topNumber: undefined,
        logoUrl: "",

        monthFirst: undefined,
        monthSecond: undefined,
        monthThird: undefined,

        weekFirst: undefined,
        weekSecond: undefined,
        weekThird: undefined,

        integralHlf: undefined,
        integral199: undefined,
        integral299: undefined,
        status: 0,
        id: "",
      },
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    ElFormItem,
    CommonElForm,
    SelectLevel,
  },
  computed: {
    submitData() {
      this.params = {
        gameName: this.formModel.gameName,
        topNumber: this.formModel.topNumber,
        logoUrl: this.formModel.logoUrl,

        monthFirst: this.formModel.monthFirst,
        monthSecond: this.formModel.monthSecond,
        monthThird: this.formModel.monthThird,

        weekFirst: this.formModel.weekFirst,
        weekSecond: this.formModel.weekSecond,
        weekThird: this.formModel.weekThird,

        integralHlf: this.formModel.integralHlf,
        integral199: this.formModel.integral199,
        integral299: this.formModel.integral299,
        id: this.formModel.id,
        status: this.formModel.status,
      };
      // console.log(this.params);
      return this.params;
    },
    submitService() {
      return APPService.rankingmanageUpdate;
    },
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.doLoad(
        APPService.rankingmanageList,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.formModel = result;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        this.getDetail();
        this.showSuccess(res.contents.optMsg);
      });
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.formModel.logoUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return isLt2M;
      }
      return isLt2M;
    },

    ...mapActions({}),
  },
};
</script>

<style scoped>
span {
  font-size: 17px;
  margin-bottom: 10px;
  display: block;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar {
  min-width: 100px;
  max-width: 100%;
  height: 100px;
  display: block;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/page/RankIng/RankIngManage.vue